import { render, staticRenderFns } from "./UserEditorInformation.vue?vue&type=template&id=58b38980&"
import script from "./UserEditorInformation.vue?vue&type=script&lang=js&"
export * from "./UserEditorInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports